export default __webpack_public_path__ + "static/media/022-v.2c056700.svg";